module.exports = __webpack_public_path__ + "img/icon_text.0eb4bd52.svg";